var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-row", { ref: "mainPlayer" }, [
    _vm.element.videoLinks[_vm.element.videoLinks.videoType].sources[0].src
      ? _c(
          "div",
          { staticClass: "player" },
          [
            _vm.showVideo
              ? _c("video-player", {
                  ref: "videoPlayer",
                  staticClass: "vjs-custom-skin",
                  attrs: {
                    options:
                      _vm.editMode === "preview"
                        ? _vm.pOption
                        : _vm.playerOptions,
                    playsinline: true,
                  },
                  on: {
                    play: function ($event) {
                      return _vm.onPlayerPlay($event)
                    },
                    ended: function ($event) {
                      return _vm.onPlayerEnded($event)
                    },
                    loadeddata: function ($event) {
                      return _vm.onPlayerLoadeddata($event)
                    },
                    waiting: function ($event) {
                      return _vm.onPlayerWaiting($event)
                    },
                    playing: function ($event) {
                      return _vm.onPlayerPlaying($event)
                    },
                    timeupdate: function ($event) {
                      return _vm.onPlayerTimeupdate($event)
                    },
                    canplay: function ($event) {
                      return _vm.onPlayerCanplay($event)
                    },
                    canplaythrough: function ($event) {
                      return _vm.onPlayerCanplaythrough($event)
                    },
                    ready: _vm.playerReadied,
                    statechanged: function ($event) {
                      return _vm.playerStateChanged($event)
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        )
      : _c("div", { staticClass: "info-class" }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("panel.link_add_tips_pre")))]),
          _c("i", { staticClass: "icon iconfont icon-chaolianjie" }),
          _c("span", [_vm._v(_vm._s(_vm.$t("panel.video_add_tips")))]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }